<template>
    <div class="text-center persistent_bottom" :class="[sheet ? 'animated fadeInUp':'']" data-wow-delay="0.6s"
         v-model="sheet" v-if="sheet">
        <v-modal-contents ref="modal_contents_policy">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title  ">
                    <div class="h2_title">Согласие на обработку персональных данных
                        в целях сбора и ведения статистики
                    </div>
                </div>
            </template>

            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="agrstat"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red"
                                @click="$refs.modal_contents_policy.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>
        <div class="persistent_bottom__wrapper d-flex align-center">
            <div class="py-3 ">

                Для улучшения работы сайта ООО «Компания Нова Ролл» может собирать данные, используя файлы
                <a :href="cookie" target="_blank">cookie</a>
                и сервис «Яндекс Метрика». Это соответствует
                <a :href="policy" target="_blank">Политике конфиденциальности</a>.
                Нажимая кнопку «Принять» вы даете
                <a href="javascript:void(0);" @click="$refs.modal_contents_policy.modal_open('scroll_false')">
                    согласие на обработку персональных данных
                </a>.

            </div>
            <v-btn class="btn_bordered persistent_bottom__btn" text @click="sheetClose()">
                Принять
            </v-btn>
        </div>
    </div>
</template>

<script>
import VModalContents from "./modal_contents.vue";

export default {
    name: "persistent_bottom",
    components: {VModalContents},
    props: {
        cookie: String | Boolean,
        policy: String | Boolean,
        agrstat: String | Boolean,
    },
    data() {
        return {
            sheet: false, // состояние всплывающего окна
        };
    },
    methods: {
        modal_open(event) {
            if (event == "scroll_false") {
                // console.log(event);
                // this.ops_scrollbar = '';
            }
            var video = document.querySelectorAll('video');
            video.forEach(function (item, index, array) {
                video[index].pause();
                // video[index].currentTime = 0;
            });


            function stopVideo() {
                video.pause();
                video.currentTime = 0;
            }

            if (this.dialog) {
                this.dialog = false;
                if ($('.contents_modal__descr iframe').length > 0) {
                    let iframe = $('.contents_modal__descr iframe');
                    let src = iframe.attr("src");
                    iframe.attr("src", src);
                }


            } else {
                this.dialog = true;
                this.autoheightcont();
            }
        },

        // Закрытие окна и запись состояния в cookies
        sheetClose() {
            this.sheet = false;
            this.setCookie('cookieConsent', 'accepted', 365); // Устанавливаем куки на 1 год
        },

        // Установка cookies
        setCookie(name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },

        // Чтение cookies
        getCookie(name) {
            const value = "; " + document.cookie;
            const parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(";").shift();
        }
    },
    mounted() {
        // Проверяем наличие куки при загрузке страницы
        const cookieConsent = this.getCookie('cookieConsent');
        if (!cookieConsent) {

            setTimeout(() => {
                this.sheet = true; // Если куки нет, показываем окно
            }, 3000)
        } else {
            this.sheet = false; // Если куки есть, не показываем окно
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../theme/_variable.scss";

.persistent_bottom {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%) !important;
  width: 100%;
  max-width: 1840px;
  min-height: 80px;
  height: max-content;
  z-index: 99999;

  @media (max-width: 1920px) {
    margin: 0 auto;
    padding: 0 40px;
  }


  &__wrapper {
    background: rgba(0, 0, 0, 0.76);
    color: #ffffff;
    text-align: start;
    border-radius: 28px;
    padding: 24px 32px;
    justify-content: space-between;

    @media (max-width: 766px) {
      flex-direction: column;

    }

    & a:hover {
      text-decoration: underline ;
    }
  }

  &__btn {
    font-family: $RobotoMedium;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0;
    text-transform: none;
    padding: 11px 20px !important;
    min-height: 40px;
    margin-left: 30px;
    background: #FA4237;
    color: #ffffff;

    @media (max-width: 766px) {
      margin-bottom: 20px;
    }
  }
}
</style>
